// extracted by mini-css-extract-plugin
export default {"PatientInfoPop":"DoctorInfoPop_PatientInfoPop__AKHnD","header":"DoctorInfoPop_header__Bubww"};